import React, { useEffect, useState } from 'react';
import ViewOrderDetails from './orderDetails';
import CustomerDetails from './customerDetails';
import ProductQuestions from './productQuestions';
import { useSelector } from 'react-redux';
import api from '../../../api/api';
import { useDispatch } from 'react-redux';
import order, {
  emptyOrderData,
  getOrderById,
} from '../../../store/reducers/order';
import { useLocation, useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { toastSuccess } from '../../../common/UI/Toasts';
import {
  isUserAdmin,
  isUserDoctor,
  isUserPharmacist,
  validateFileExtensions,
  getFormDataFromObject,
} from '../../../utils/helpers';
import InternalNotes from '../ViewOrder/internalNotes';
import { Button } from 'react-bootstrap';

const ViewOrderProductPage = () => {
  const orderData = useSelector((state) => state.order.orderData);
  const { id, variantId } = useParams();
  const [searchParams] = useSearchParams();
  const itemId = searchParams.get('itemId');
  const dispatch = useDispatch();
  const [thisOrderItem, setThisOrderItem] = useState();
  const [instruction, setInstruction] = useState('');
  const navigate = useNavigate();
  const location = useLocation();
  const [orderImages, setOrderImages] = useState();
  const [uploadImageForm, setUploadImageForm] = useState(false);
  const [fullBodyPic, setFullBodyPic] = useState();
  const [photoId, setPhotoId] = useState();
  const [buttonClicked, setButtonClicked] = useState(false);
  const [userVideo, setUserVideo] = useState();
  const [videoSource, setVideoSource] = useState();
  const [videoFile, setVideoFile] = useState();
  const [showImageModal, setShowImageModal] = useState(false);
  const [previewImage, setPreviewImage] = useState(null);


  useEffect(() => {
    if (orderData) {
      let thisProductData = orderData?.orderItem.find(
        (el) => el._id === itemId,
      );
      setThisOrderItem(thisProductData);
      setInstruction(thisProductData?.instruction || '');
      api.getOrderImages(orderData._id).then((res) => {
        setOrderImages(res.data.data[0]);
      });
    }
  }, [orderData]);

  const onChangeOfInstructionInput = (e) => {
    setInstruction(e.target.value);
  };

  const handleUploadBodyImage = (imageData) => {
    api
      .uploadOrderImage(getFormDataFromObject({ photos: imageData.answer }))
      .then((res) => {
        setFullBodyPic(res.data.data.photos[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleUploadIDImage = (imageData) => {
    api
      .uploadOrderImage(getFormDataFromObject({ photos: imageData.answer }))
      .then((res) => {
        setPhotoId(res.data.data.photos[0]);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const submitOrderImages = () => {
    let payload = {};

    if (fullBodyPic != null && photoId != null) {
      payload = {
        userPicture: fullBodyPic,
        userIdPicture: photoId,
      };
    } else if (fullBodyPic != null && photoId == null) {
      payload = {
        userPicture: fullBodyPic,
      };
    } else if (fullBodyPic == null && photoId != null) {
      payload = {
        userIdPicture: photoId,
      };
    }
    setButtonClicked(true);
    api
      .submitOrderImage(orderData._id, payload)
      .then((res) => {
        if (res.data.message == 'Image uploded successfully') {
          navigate(0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const saveInstructions = () => {
    const payload = {
      instruction: instruction,
    };

    api
      .setInstructionForProductLabel(thisOrderItem?._id, payload)
      .then((res) => {
        toastSuccess('Added Instruction Successfully');
        dispatch(getOrderById(id));
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  return (
    <>
      {!uploadImageForm ? (
        <>
          <div className="row">
            <div className="col-md-12">
              <ol className="breadcrumb">
                <li>
                  <p
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      dispatch(emptyOrderData());
                      navigate(
                        location.state?.allOrdersPath
                          ? location.state?.allOrdersPath
                          : -2,
                        {
                          state: {
                            ...location.state,
                          },
                        },
                      );
                    }}
                    title="Product Management"
                  >
                    All Orders
                  </p>
                </li>
                <li>
                  <p
                    style={{ cursor: 'pointer' }}
                    onClick={() => {
                      navigate(`/vieworder/${id}`);
                    }}
                    title="Product Management"
                  >
                    View Order
                  </p>
                </li>
                <li>View Order Product</li>
              </ol>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 col-xl-12 col-xxl-6 mb-3">
              <ViewOrderDetails key={orderData?._id} orderData={orderData} />
            </div>
            <div className="col-md-12 col-xl-12 col-xxl-6 mb-3">
              <CustomerDetails key={orderData?._id} orderData={orderData} />
            </div>
          </div>
          {(orderImages?.userPicture || orderImages?.userIdPicture) && (
            <div className="box_main">
              <div className="header_top">
                <h3>Full Body Picture & Photo Id</h3>
              </div>
              <div className="row order-images-section">
                {orderImages?.userPicture?.isdeleted ? (
                  <p>User Image was uploaded</p>
                ) : (
                  <>
                    {orderImages?.userPicture?.location ? (
                      <img
                        src={orderImages?.userPicture?.location}
                        alt=""
                        style={{
                          borderRadius: '16px',
                          width: '300px',
                          height: '150px',
                          objectFit: 'contain',
                        }}
                      />
                    ) : (
                      <></>
                    )}
                  </>
                )}
                {orderImages?.userIdPicture?.isdeleted ? (
                  <p>User ID was uploaded</p>
                ) : (
                  <>
                    {orderImages?.userIdPicture?.location && (
                      <>
                        <div
                          style={{
                            position: 'relative',
                            display: 'inline-block',
                            width: '300px',
                            height: '150px',
                            cursor: 'pointer',
                          }}
                        >
                          <img
                            src={orderImages?.userIdPicture?.location}
                            alt=""
                            onClick={() => setShowImageModal(true)}
                            style={{
                              borderRadius: '16px',
                              width: '100%',
                              height: '100%',
                              objectFit: 'contain',
                            }}
                          />

                          <button
                            onClick={(e) => {
                              e.stopPropagation(); // prevent modal open
                              handleDeletePhoto('userIdPicture');
                            }}
                            style={{
                              position: 'absolute',
                              top: '5px',
                              right: '5px',
                              background: 'rgba(255, 0, 0, 0.7)',
                              color: 'white',
                              border: 'none',
                              borderRadius: '50%',
                              width: '25px',
                              height: '25px',
                              cursor: 'pointer',
                              fontSize: '16px',
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'center',
                              padding: '0',
                            }}
                            title="Delete image"
                          >
                            ×
                          </button>
                        </div>

                        {/* Modal */}
                        {showImageModal && (
                          <div style={modalOverlay}>
                            <div style={modalContent}>
                              <button
                                onClick={() => setShowImageModal(false)}
                                style={closeBtn}
                              >
                                ×
                              </button>

                              <img
                                src={orderImages?.userIdPicture?.location}
                                alt=""
                                style={{
                                  maxWidth: '90vw',
                                  maxHeight: '90vh',
                                  borderRadius: '16px',
                                }}
                              />
                            </div>
                          </div>
                        )}
                      </>
                    )}
                  </>
                )}
              </div>
            </div>
          )}
          <button
            className={`btn btn-primary border-radius-24 fs-16 shadow-none shadow-focus-none my-1`}
            onClick={() => setUploadImageForm(true)}
          >
            Upload ID or full body image
          </button>
          {thisOrderItem?.product?.type === 'medication' ? (
            <div className="row">
              <div className="col-md-12 mb-3">
                <div
                  className="header_top "
                  style={{ justifyContent: 'space-between' }}
                >
                  <h3>Add Instructions</h3>
                </div>

                <div className="d-flex">
                  <div
                    style={{
                      width: '40%',
                    }}
                  >
                    <textarea
                      disabled={isUserPharmacist()}
                      className="mt-4 form-control form-textarea"
                      rows="3"
                      value={instruction}
                      onChange={(e) => onChangeOfInstructionInput(e)}
                      placeholder="Write the instructions here..."
                      style={{ width: '100%', borderRadius: '0.5rem' }}
                    />
                    {instruction != '' &&
                    (!thisOrderItem.instruction ||
                      thisOrderItem.instruction != instruction) ? (
                      <span className="text-danger">
                        {thisOrderItem.instruction &&
                        thisOrderItem.instruction != instruction
                          ? `You have updated the instruction but haven't saved it.`
                          : `Instruction is not saved yet.`}
                      </span>
                    ) : null}
                  </div>
                  <div className="mt-4 ms-3">
                    {isUserDoctor() || isUserAdmin() ? (
                      <button
                        className="btn btn-primary mt-3"
                        onClick={saveInstructions}
                        disabled={!instruction || instruction == ''}
                      >
                        Save
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
              <div className="col-md-12 mb-3">
                <div className="box_main">
                  <div className="middle_main">
                    <InternalNotes />
                  </div>
                </div>
              </div>
              {(isUserDoctor() || isUserAdmin() || isUserPharmacist()) && (
                <div className="col-md-12">
                  <ProductQuestions
                    OrderItem={thisOrderItem}
                    orderStatus={orderData.current_order_status}
                  />
                </div>
              )}
            </div>
          ) : null}
        </>
      ) : (
        <>
          <div
            className="
           "
          >
            <div className="container-fluid">
              <div className="row">
                <div className="col-md-12">
                  <div className="box_main">
                    <Button
                      type="button"
                      variant="sky"
                      className="my-2 me-2"
                      onClick={() => setUploadImageForm(false)}
                    >
                      Back
                    </Button>
                    <div className="d-flex">
                      <label
                        className="p-2 text-center mt-2 mx-2 d-flex align-items-center justify-content-center"
                        style={{
                          borderRadius: '32px',
                          height: '52px',
                          border: '1px solid #ccc',
                          display: 'inline-block',
                          padding: ' 10px 22px',
                          cursor: 'pointer',
                          fontSize: '15px',
                        }}
                      >
                        {fullBodyPic ? (
                          <span className={``} onClick={() => {}}>
                            {fullBodyPic.originalname}
                          </span>
                        ) : (
                          'Upload your Full body Picture'
                        )}
                        <input
                          type="file"
                          accept="image/png, image/svg, image/jpeg, image/jpg, image/webp, image/heic"
                          style={{ width: '300px', display: 'none' }}
                          onChange={(e) => {
                            if (validateFileExtensions(e.target.files[0])) {
                              handleUploadBodyImage({
                                answer: e.target.files[0],
                                prevUrl: URL.createObjectURL(e.target.files[0]),
                              });
                            }
                          }}
                        />
                      </label>

                      <label
                        className="p-2 text-center mt-2 mx-2 d-flex align-items-center justify-content-center"
                        style={{
                          borderRadius: '32px',
                          height: '52px',
                          border: '1px solid #ccc',
                          display: 'inline-block',
                          padding: ' 10px 22px',
                          cursor: 'pointer',
                          fontSize: '15px',
                        }}
                      >
                        {photoId ? (
                          <span className={``} onClick={() => {}}>
                            {photoId.originalname}
                          </span>
                        ) : (
                          'Upload a photo ID'
                        )}
                        <input
                          type="file"
                          accept="image/png, image/svg, image/jpeg, image/jpg, image/webp, image/heic"
                          style={{ width: '300px', display: 'none' }}
                          onChange={(e) => {
                            if (validateFileExtensions(e.target.files[0])) {
                              handleUploadIDImage({
                                answer: e.target.files[0],
                                prevUrl: URL.createObjectURL(e.target.files[0]),
                              });
                            }
                          }}
                        />
                      </label>
                    </div>
                    <div>
                      <button
                        onClick={() => {
                          submitOrderImages();
                        }}
                        className={`btn btn-primary border-radius-24 fs-16 shadow-none shadow-focus-none my-1`}
                      >
                        {buttonClicked ? 'Loading...' : 'Submit'}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {previewImage && (
            <div
              style={modalOverlay}
              onClick={() => setPreviewImage(null)}
            >
              <div
                style={modalContent}
                onClick={(e) => e.stopPropagation()}
              >
                <button
                  onClick={() => setPreviewImage(null)}
                  style={closeBtn}
                >
                  ×
                </button>

                <img
                  src={previewImage}
                  alt=""
                  style={{
                    maxWidth: '90vw',
                    maxHeight: '90vh',
                    borderRadius: '16px',
                  }}
                />
              </div>
            </div>
          )}

        </>

      )}
    </>
  );
};

const modalOverlay = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100vw',
  height: '100vh',
  background: 'rgba(0,0,0,0.6)',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  zIndex: 9999,
};

const modalContent = {
  position: 'relative',
  background: '#fff',
  padding: '20px',
  borderRadius: '12px',
};

const closeBtn = {
  position: 'absolute',
  top: '5px',
  right: '10px',
  background: 'transparent',
  border: 'none',
  fontSize: '24px',
  cursor: 'pointer',
};


export default ViewOrderProductPage;
